import { z } from 'zod'

import { HandoverAppRoleType } from 'common/settings/constants/HandoverAppRoleType'

export const HandoverSchema = z.object({ app_role: z.enum(HandoverAppRoleType) })
